<template>
  <!-- App Store Guideline 3.1.2: subscription surfaces must carry functional
       links to the privacy policy and Terms of Use (EULA). Extracted from
       UpgradeOptions so every surface that shows plans (upgrade cards, the
       onboarding plan picker) carries the same links from one definition
       instead of copying the markup. -->
  <div class="legal-links">
    <router-link to="/privacy-policy">{{ $t('pricing.privacyPolicy') }}</router-link>
    <span class="legal-links-separator" aria-hidden="true">·</span>
    <router-link to="/terms-of-service">{{ $t('pricing.termsOfUse') }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'PlanLegalLinks',
};
</script>

<style scoped>
.legal-links {
  text-align: center;
  margin-top: var(--al-space-lg);
  font-size: 0.8rem;
}

.legal-links a {
  color: var(--al-text-muted);
  text-decoration: underline;
}

.legal-links a:hover {
  color: var(--al-text);
}

.legal-links-separator {
  color: var(--al-text-muted);
  margin: 0 var(--al-space-sm);
}
</style>
